function StrategicValue() {
  return (
    <section className="strategic-value">
      <div className="wrap">
        <div className="section-head">
          <div className="eyebrow">Strategic value</div>
          <h2>
            <span className="intro-title-line">From risk insight</span>
            <span className="intro-title-line">to market action.</span>
          </h2>
          <p>Insurers face interconnected exposures, shifting capacity and increasing pressure to deploy capital efficiently. WillMars brings together portfolio analysis, market relationships and placement discipline to help clients move from risk understanding to programme action.</p>
        </div>
        <div className="strategy-grid">
          <article className="strategy-card">
            <span className="strategy-num">01 · UNDERSTAND</span>
            <h3>Clarify the changing risk picture</h3>
            <p>We examine portfolio performance, concentrations, emerging exposures and loss experience to build a clearer view of the risks that matter.</p>
            <span className="strategy-arrow">→</span>
          </article>
          <article className="strategy-card">
            <span className="strategy-num">02 · ALIGN</span>
            <h3>Connect protection with capital priorities</h3>
            <p>Programme structure, retention and capacity are considered together so protection supports underwriting objectives and financial resilience.</p>
            <span className="strategy-arrow">→</span>
          </article>
          <article className="strategy-card">
            <span className="strategy-num">03 · ENABLE</span>
            <h3>Support performance and sustainable growth</h3>
            <p>Relevant market access and well-prepared submissions help insurers pursue opportunity while managing volatility across portfolios and territories.</p>
            <span className="strategy-arrow">→</span>
          </article>
          <article className="strategy-card">
            <span className="strategy-num">04 · CONTINUE</span>
            <h3>Remain engaged through claims and renewal</h3>
            <p>Our role continues after placement through documentation, claims coordination, programme review and learning for the next renewal cycle.</p>
            <span className="strategy-arrow">→</span>
          </article>
        </div>
      </div>
    </section>
  )
}

export default StrategicValue
